// RPM to Rad/s Converter (Rotational Speed Converter) tool: unit metadata + client-side
// field validation, used for instant inline feedback as the user types. The actual
// conversion math and the authoritative (server-side) validation live in the main
// backend — see src/lib/toolsApi.js (rotationalSpeedToolApi) and
// backend/tools/rotational_speed_tool.py.

export const DEFAULT_INPUTS = {
  unit: 'rpm',
  value: 1000,
};

// Order here drives the order results are displayed in.
export const UNITS = [
  { value: 'rpm', label: 'RPM', name: 'Revolutions per Minute' },
  { value: 'rps', label: 'RPS', name: 'Revolutions per Second' },
  { value: 'radps', label: 'rad/s', name: 'Radians per Second' },
  { value: 'degps', label: '°/s', name: 'Degrees per Second' },
];

// The entered value may be positive, negative, or zero — rotational direction is
// meaningful — so there is no strictlyPositive floor, only a wide sanity ceiling applied
// symmetrically to both signs. Mirrors FIELD_SPECS in
// backend/core/lookup/rotational_speed_specs.py exactly.
export const FIELD_SPECS = [
  { key: 'value', label: 'Value', unit: '', group: 'input', min: -1000000, max: 1000000, strictlyPositive: false },
];

export const PRECISION_OPTIONS = [2, 3, 4, 5, 6];
export const DEFAULT_PRECISION = 4;

export function validateField(spec, rawValue) {
  if (rawValue === '' || rawValue === null || rawValue === undefined) {
    return 'Required.';
  }
  const value = Number(rawValue);
  if (Number.isNaN(value)) {
    return 'Must be a number.';
  }
  if (spec.strictlyPositive && value <= 0) {
    return 'Must be greater than 0.';
  }
  if (spec.min !== null && value < spec.min) {
    return `Must be ≥ ${spec.min}.`;
  }
  if (spec.max !== null && value > spec.max) {
    return `Must be ≤ ${spec.max}.`;
  }
  return null;
}
